import styled from 'styled-components';
import { colors } from 'globalStyles';

export const Card = styled.div`
  max-width: 480px;
  margin: 60px auto;
  padding: 40px;
  text-align: center;
  background: ${colors.WHITE};
  border-radius: 4px;

  > h1 {
    color: ${colors.RED};
  }
`;

export const BackLink = styled.div`
  margin-top: 25px;

  > a {
    color: ${colors.MAIN_COLOR};
    text-decoration: underline;
  }

  > a:hover,
  > a:focus-visible {
    text-decoration: none;
  }
`;
